import { UnauthenticatedLayout } from "Components/Layout/UnauthenticatedLayout";
import { useNavigate } from "Navigation/useNavigate";
import { verifyEmailAsync } from "State/Auth/Verifications/EmailVerificationState";
import React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

export const EmailVerificationPage = () => {
  const { token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (token) {
      dispatch(verifyEmailAsync.request({ command: { token }, navigate }));
    }
  }, [dispatch, navigate, token]);

  return <UnauthenticatedLayout title="Verifikace e-mailu" />;
};

export default EmailVerificationPage;
